import React from 'react';
import RadioList from '../RadioList';

const YesNo = props => (
  <RadioList
    {...props}
    options={[{ order: 0, text: 'Yes' }, { order: 1, text: 'No' }]}
  />
);

export default YesNo;



// WEBPACK FOOTER //
// ./src/App/account/components/Surveys/QuestionGroup/InputTypes/YesNo/index.js